import { gql } from '@apollo/client';

export const userDetailsQuery = gql`
  query {
    core {
      getCurrentUser {
        access
        accessFailedCount
        code
        concurrencyStamp
        email
        emailConfirmed
        firstName
        id
        lastName
        lockoutEnabled
        lockoutEnd
        middleName
        normalizedEmail
        normalizedUserName
        passwordHash
        phoneNumber
        phoneNumberConfirmed
        securityStamp
        status
        twoFactorEnabled
        type
        userName
        allowPolicyCorrection
        allowPolicyEndorsement
        allowPolicyCancellation
        allowTransactionModification
        planCoverEditRights
        userRoles {
          role {
            name
          }
        }
        editableChargesLines {
          lineID
        }
      }
    }
  }
`;

export const getAppVisibilitySettings = gql`
  mutation getAppVisibilitySettings {
    insurance {
      actions {
        getAppVisibilitySettings {
          IsPlanConfigurationEnabled
          IsSalesForceAppEnabled
        }
      }
    }
  }
`;

export const getGlobalLovs = gql`
  query getGlobalLovs {
    Core {
      lookups {
        currencies {
          Id
          Code
          Symbol
          Title
        }
      }
    }
    SalesforceManagement {
      lookups {
        relatedCompanies {
          Id
          Code
          Title
        }
      }
    }
  }
`;
